import Svg, { Path } from 'react-native-svg'

const MyAccountIcon = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M7 12a5 5 0 0 0-5 5 2 2 0 0 0 2 2h6a2 2 0 0 0 2-2 5 5 0 0 0-5-5Zm0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm14 4h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2Zm0-6a1 1 0 1 0 0-2h-8a1 1 0 1 0 0 2h8Zm0 2h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2Z"
    />
  </Svg>
)
export default MyAccountIcon
